import Services from "./Services";
import MiniServices from "./MiniServices";

export { MiniServices, Services };
export default Services;
